module.exports = "/_next/static/images/loved-by-employees-936b602f8b9f1d1520888a4fc2c19170.png";